module.exports = __webpack_public_path__ + "static/media/decentlabs.14e14bed.png";